"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Svg_1 = __importDefault(require("../Svg"));

var RezdyMark = function RezdyMark(_a) {
  var fill = _a.fill,
      props = __rest(_a, ["fill"]);

  return react_1.default.createElement(Svg_1.default, __assign({}, props, {
    viewBox: "0 0 194.4 49.5"
  }), react_1.default.createElement("path", {
    fill: fill,
    className: "st0",
    d: "M129.6,37.5c1.9,0.1,3.6-0.1,4.6-2c0.9-1.8,0.3-3.3-1.4-4.7c-1.6-1.3-5.7,0-6.2,1.9\n\tC126.1,34.5,127.2,37.3,129.6,37.5"
  }), react_1.default.createElement("path", {
    fill: fill,
    className: "st0",
    d: "M123.3,31.3c0-0.9-2.2-1.2-2.2-1.2c-5.5-1.8,8.8-6.3,12.9-9c5.9-3.6,1.9-11.4-4.2-8.4c-2.4,1.1-6.9,0.3-8.7-2.3\n\tc-3.1-5.4-12.6-2.1-9.9,4.1c1.6,3.3,4.9,4.7,8.4,2.9c4.8-2.1,9,1.8,3.6,4.6c-0.1,0.1-11.6,6-11.7,6.1c-4.9,2.3-1.8,8.4,3.4,6.5\n\tc3.8-1.4,5.2-2,6.5-1.6C122.1,33.1,123.3,32.9,123.3,31.3"
  }), react_1.default.createElement("path", {
    fill: fill,
    className: "st1",
    d: "M61.9,38.7c0,0-0.5,0-0.4-0.5c0.1-0.6,5.7-26.8,5.7-26.8c2.2-1.9,6.5-2.9,12.9-2.9l1.6,0c0,0,0.8,0,0.7,0.8\n\tc-0.1,0.6-0.9,4.2-1,4.9c-0.2,0.7-1.1,0.6-1.1,0.6h-1.5c-1.9,0-3.5,0.3-4.8,1c0,0-4.6,21.4-4.7,22.2c-0.2,0.8-0.9,0.7-0.9,0.7\n\tL61.9,38.7z"
  }), react_1.default.createElement("path", {
    fill: fill,
    className: "st1",
    d: "M89.8,21h9l0.4-1.7c0.1-0.6,0.2-1.2,0.2-1.6c0-2.1-1.2-3.2-3.6-3.2c-3.1,0.1-4.9,1.7-5.6,4.8L89.8,21L89.8,21z\n\t M102.5,37.2c-3.6,0.9-7.3,1.4-11.1,1.4c-7.4,0-11-2.6-11-7.8c0-0.9,0.1-1.9,0.3-3l1.8-8.6c1.6-7.4,6.4-11,14.5-11\n\tc6.8,0,10.2,2.6,10.2,7.7c0,1-0.1,2.1-0.4,3.3l-1.4,6.6H88.8l-0.4,2c-0.1,0.4-0.1,0.9-0.1,1.2c0,2.2,1.5,3.2,4.5,3.2\n\tc0.7,0,1.4,0.1,2.2,0.1c3,0,5.9-0.3,8.7-0.9c0,0,0.8-0.3,0.6,0.6c-0.2,0.7-0.8,3.8-0.9,4.4C103,37.2,102.5,37.2,102.5,37.2"
  }), react_1.default.createElement("path", {
    fill: fill,
    className: "st1",
    d: "M158.1,15.4c-1.5-0.6-3.1-0.9-4.9-0.9c-2.6,0-4.3,1.5-4.9,4.5l-1.9,8.9c-0.1,0.6-0.2,1.1-0.2,1.6\n\tc0,1.9,1.1,2.9,3.2,2.9h5.1L158.1,15.4L158.1,15.4z M159.4,38.4l-10.8,0.2c-6.8,0-10.2-2.6-10.2-7.7c0-1,0.1-2.1,0.4-3.3l1.7-8.3\n\tc1.6-7.4,5.5-11,11.7-11c2.7,0,5,0.6,6.9,1.9c0,0,2.2-10.1,2-9.3c-0.1,0.5,0-0.7,0.9-0.7c0.7,0,5.5,0,6.3,0c0.8,0,0.5,0.7,0.5,0.7\n\ts-7.4,34.9-7.7,36.3C160.8,38.6,159.4,38.4,159.4,38.4"
  }), react_1.default.createElement("path", {
    fill: fill,
    className: "st1",
    d: "M164.6,47.5c0.1-0.7,0.8-3.9,0.9-4.4c0.2-0.7,0.8-0.4,0.8-0.4c1.5,0.4,3.3,0.7,5.3,0.7c1,0,2.1-0.1,3.3-0.2\n\tc3,0,4.8-1.5,5.4-4.5l0.4-1.7c-2.1,1.1-4.3,1.7-6.6,1.7c-0.3,0-0.7,0-1,0c-5-0.1-7.5-2.6-7.5-7.2c0-1.1,0.1-2.4,0.4-3.8L170,9.3\n\tc0,0,0-0.9,1.1-0.9c0.8,0,4.9,0,5.9,0c1,0,0.7,0.8,0.7,0.8l-3.9,18.3c-0.1,0.6-0.2,1.2-0.2,1.7c0,2,1,3,3.1,3c1.7,0,3.5-0.3,5.2-0.9\n\tl4.7-22.1c0,0,0.1-0.8,1-0.8c0.7,0,5.8,0,6.3,0c0.6,0,0.5,0.6,0.5,0.6l-6.3,29.6c-1.5,7.2-6.3,10.8-14.4,10.8\n\tc-0.6,0-1.1,0.1-1.7,0.1c-2.8,0-5-0.4-6.9-1.1C165.1,48.4,164.5,48.3,164.6,47.5"
  }), react_1.default.createElement("path", {
    fill: fill,
    className: "st1",
    d: "M35.6,23c-4.1,2.7-18.7,7.3-13.1,9.2c0,0,2.2,0.3,2.2,1.2c0,1.6-1.3,1.8-1.8,1.7c-1.4-0.4-2.7,0.3-6.6,1.6\n\tc-5.3,1.9-8.4-4.2-3.5-6.6C13,30,24.6,24,24.7,24c5.5-2.9,1.2-6.8-3.7-4.7c-3.5,1.8-6.9,0.4-8.5-2.9c-2.7-6.3,6.9-9.7,10.1-4.2\n\tc1.8,2.6,6.4,3.4,8.8,2.3C37.6,11.4,41.6,19.3,35.6,23 M37.1,38.2c-1,2-2.8,2.2-4.7,2.1c-2.5-0.2-3.6-3.1-3.1-5c0.5-2,4.8-3.3,6.4-2\n\tC37.4,34.8,38,36.4,37.1,38.2 M24.7,0C11.1,0,0,11.1,0,24.7c0,13.6,11.1,24.7,24.7,24.7c13.6,0,24.7-11.1,24.7-24.7\n\tC49.4,11.1,38.3,0,24.7,0"
  }));
};

exports.default = RezdyMark;
RezdyMark.displayName = 'RezdyLogo';